module.exports = __webpack_public_path__ + "static/media/IncompleteIcon.104a85e6.svg";